export const configSSO = {
  issuer: 'https://sts.inforius.be',
  postLogoutRedirectUri: 'https://idep-bo.myinforius.be/',
  redirectUri: 'https://idep-bo.myinforius.be/callback',
  clientId: 'idep_backoffice',
  oidc: true,
  userinfoEndpoint: 'https://sts.inforius.be/connect/userinfo',
  useSilentRefresh: true,
  scope: 'openid profile email idep.backoffice.api',
  showDebugInformation: false,
  silentRefreshRedirectUri:
    'https://idep-bo.myinforius.be/silent-renew.html',
  responseType: 'code',
  enableLogConsole: false,
};